import React, { useContext, useState, useEffect } from 'react'
import { mapData } from '@/product/common/components'
import { useFormik } from 'formik'
import * as Yup from 'yup'
import { Button, Dialog } from '@mui/material'
import PrimaryButton from '@/product/components/atoms/PrimaryButton'

import SettingContext from '@/product/context/setting/settingContext'
import CloseIcon from '@mui/icons-material/Close'
import CustomCommonContext from '@/custom/context/common/commonContext'
import Slide from '@mui/material/Slide'

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />
})

const DropdownValueManage = (props) => {
    const { alldata_all_dropdown } = useContext(CustomCommonContext)
    const [reload, setReload] = useState(false)
    const [isLoading, setIsLoading] = useState(false)

    const settingcontext = useContext(SettingContext)

    const {
        searchTableAction,
        searchTableFetch,
        search_fetch_data,
        responseStatus: responseStatusSetting,
        clearResponse: clearResponseCommuncation,
    } = settingcontext

    const validationArrayDrop = Yup.object({
        description: Yup.string().required('Required!'),
        // value: Yup.boolean().when('diff_value', {
        //     is: true,
        //     then: Yup.string().required('Required!'),
        // }),
    })

    const data = props.data
    const toggleFullScreenDropPopup = props.function

    const formikDrop = useFormik({
        initialValues: {
            id: 0,
            description: '',
            value: '',
            diff_value: false,
            avatar: [],
            for_arabic: '',
            min: 0,
            max: 0,
            level: 0,
            level_id: 0,
            show_order: props.show_order,
            active: 1,
            table: props.table ? props.table : 'data_all_dropdown',
        },
        validateOnBlur: false,
        validationSchema: validationArrayDrop,
        onSubmit: (values) => {
            console.log('+++++++++++++', values)
            if (values.level_id) {
                formikDrop.values.level = 1
            }
            searchTableAction(values, false, 'data_all_dropdown')
            setIsLoading(true)
        },
    })

    const resetFromDrop = () => {
        formikDrop.setFieldValue('id', 0)
        formikDrop.setFieldValue('description', '')
        formikDrop.setFieldValue('variable', props.name)
        formikDrop.setFieldValue('diff_value', false)
        formikDrop.setFieldValue('value', '')
        formikDrop.setFieldValue('avatar', [])
        formikDrop.setFieldValue('for_arabic', '')

        formikDrop.setFieldValue('min', 0)
        formikDrop.setFieldValue('max', 0)
        formikDrop.setFieldValue('level', 0)
        formikDrop.setFieldValue('sub_value', 0)
        formikDrop.setFieldValue('level_id', 0)
        formikDrop.setFieldValue('show_order', props.show_order)
        formikDrop.setFieldValue('active', 1)
        formikDrop.handleReset()
        setReload(!reload)
    }

    useEffect(() => {
        if (data.status === 'edit') {
            formikDrop.setFieldValue('id', data.data.id)
            const template = data.data
            console.log('template', template.diff_value)
            formikDrop.setFieldValue('description', template.description)
            formikDrop.setFieldValue(
                'diff_value',
                template.diff_value ? true : false
            )
            formikDrop.setFieldValue('variable', template.variable)
            formikDrop.setFieldValue('value', template.value)
            formikDrop.setFieldValue(
                'avatar',
                template.avatar ? template.avatar.split(',') : []
            )
            formikDrop.setFieldValue('for_arabic', template?.for_arabic || '')

            formikDrop.setFieldValue('min', template.min)
            formikDrop.setFieldValue('max', template.max)
            formikDrop.setFieldValue('level', template.level)
            formikDrop.setFieldValue('level_id', template.level_id)
            formikDrop.setFieldValue('show_order', template.show_order)
            formikDrop.setFieldValue('active', template.active)
            setIsLoading(false)
        } else {
            resetFromDrop()
            setIsLoading(false)
        }
    }, [data])

    useEffect(() => {
        if (props.show_order) {
            formikDrop.setFieldValue('show_order', props.show_order)
        }
    }, [props.show_order])

    useEffect(() => {
        if (props.name) {
            formikDrop.setFieldValue('variable', props.name)
            setReload(!reload)
        }
    }, [props.name])

    const detailsDrop = {
        formik: formikDrop,
        data: [
            {
                label: 'Description',
                placeholder: 'Enter a Description',
                type: 'text',
                class: 'col-sm-12 col-12',
                name: 'description',
            },
            {
                label: 'Value',
                placeholder: 'Enter a Value',
                type: 'text',
                class: `col-sm-12 col-12 ${props.diff_value ? '' : 'd-none'}`,
                name: 'value',
            },
            {
                label: 'Arabic Description',
                placeholder: 'Enter Arabic Description',
                type: 'text',
                class: `col-sm-12 col-12 ${
                    props.custom_language ? '' : 'd-none'
                }`,
                name: 'for_arabic',
            },
            {
                type: 'uploadDropZone',
                name: 'avatar',
                titleText: 'Upload image',
                innerText: 'Recommended Aspect Ratio: 5:3',
                class: `col-sm-12 col-12 ${props.avatar ? '' : 'd-none'}`,
                folder: 'product',
                multiple: false,
                accept: 'image/*',
            },

            {
                label: 'Parent Category',
                placeholder: 'Select a Parent Category',
                type: 'select',
                class: `col-sm-12 col-12 ${
                    props.subLevel === 1 ? '' : 'd-none'
                }`,
                name: 'level_id',
                options: alldata_all_dropdown
                    .filter(
                        (value) =>
                            value.variable === props.subField &&
                            value.level === 0
                    )
                    .map((maincat) => {
                        let categoryChanged = {}
                        categoryChanged.show = maincat.description
                        categoryChanged.value = maincat.id
                        return categoryChanged
                    }),
            },
        ],
    }

    return (
        <>
            <Dialog
                className="dropdownManageModal"
                open={data.popup}
                onClose={() => {
                    ;(toggleFullScreenDropPopup(false, 'new', 0),
                        'backdropClick')
                }}
                TransitionComponent={Transition}
            >
                <>
                    <Button
                        className="closeIcon"
                        onClick={() =>
                            toggleFullScreenDropPopup(false, 'new', 0)
                        }
                    >
                        <CloseIcon />
                    </Button>
                    <h2 className="ddmTitle">
                        {data.status === 'new'
                            ? props.dropDownName
                                ? props.dropDownName
                                : `Add a new dropdown value`
                            : props.dropDownNameEdit
                              ? props.dropDownNameEdit
                              : 'Edit dropdown value'}
                    </h2>
                    <form
                        onSubmit={formikDrop.handleSubmit}
                        autoComplete="nofill"
                    >
                        <div className="row">{mapData(detailsDrop)}</div>
                        <div className="actionButton d-flex justify-content-center align-items-center">
                            {/* <SecondaryButton
                                id="dynamic_drop_reset"
                                label="Reset"
                                type="reset"
                                onClick={() => resetFromDrop()}
                            /> */}
                            <PrimaryButton
                                id="dynamic_drop_submit"
                                type="submit"
                                label="Submit"
                            />
                        </div>
                    </form>
                </>
            </Dialog>
        </>
    )
}

export default DropdownValueManage
